import { useState } from "react";
import { useTexts } from "../texts";
import { PageHead, useToast } from "../ui/kit";
import { Pager } from "../ui/list";
import {
  Chain,
  CodeBlock,
  CopyCode,
  OnceSecret,
  PageState,
  PasswordField,
  ServiceState,
  type ChainRow,
} from "../ui/pieces";

// Banco de prueba de las piezas compartidas del Admin (R1 · A4): cada pieza con sus estados, en claro y oscuro, para el
// contrato visual y las capturas. No tiene entrada en el menú ni datos de empresas; los valores son de muestra.

const sampleChain: ChainRow[] = [
  { key: "a", name: "modelo-principal", line: "Proveedor A · US$ 0.40 / 1.60 por 1M" },
  { key: "b", name: "modelo-respaldo", line: "Proveedor B · US$ 0.30 / 2.50 por 1M" },
  { key: "c", name: "modelo-tercero", line: "Proveedor C · —" },
];

export function PiecesPage() {
  const { L } = useTexts();
  const toast = useToast();
  const [rows, setRows] = useState(sampleChain);
  const [secret, setSecret] = useState("");
  const move = (from: number, to: number) => {
    const before = rows;
    const next = [...rows];
    const [item] = next.splice(from, 1);
    next.splice(to, 0, item!);
    setRows(next);
    toast.show(L("ADM_CHAIN_MOVED"), { label: L("ADM_UNDO"), run: () => setRows(before) });
  };
  const remove = (index: number) => {
    const before = rows;
    setRows(rows.filter((_, position) => position !== index));
    toast.show(L("ADM_CHAIN_REMOVED"), { label: L("ADM_UNDO"), run: () => setRows(before) });
  };
  const tones = (index: number) =>
    [
      <ServiceState key="ok" tone="ok">
        {L("ADM_STATE_OK")}
      </ServiceState>,
      <ServiceState key="warn" tone="warn">
        {L("ADM_STATE_REVIEW")}
      </ServiceState>,
      <ServiceState key="off" tone="off">
        {L("ADM_STATE_OFF")}
      </ServiceState>,
    ][index % 3];
  return (
    <div className="npa-pieces">
      <PageHead title={L("ADM_PIECES_TITLE")} sub={L("ADM_PIECES_SUB")} />
      <section data-ref="estado-servicio">
        <h2 className="tm-subtitle">C55</h2>
        <div className="npa-pieces-row">
          <ServiceState tone="ok">{L("ADM_STATE_OK")}</ServiceState>
          <ServiceState tone="warn">{L("ADM_STATE_REVIEW")}</ServiceState>
          <ServiceState tone="fail">{L("ADM_STATE_FAILED")}</ServiceState>
          <ServiceState tone="off">{L("ADM_STATE_OFF")}</ServiceState>
        </div>
      </section>
      <section data-ref="cadena-modelos">
        <h2 className="tm-subtitle">C50</h2>
        <Chain rows={rows.map((row, index) => ({ ...row, state: tones(index) }))} onMove={move} onRemove={remove} />
      </section>
      <section data-ref="dato-una-vez">
        <h2 className="tm-subtitle">C51</h2>
        <OnceSecret
          label={L("ADM_SAMPLE_SECRET_LABEL")}
          value="Kx7#mPq2-Lr9w"
          help={L("ADM_SAMPLE_SECRET_HELP")}
          copiedMessage={L("ADM_SAMPLE_SECRET_COPIED")}
        />
      </section>
      <section data-ref="codigo-copiable">
        <h2 className="tm-subtitle">C52 · C40</h2>
        <PageState title={L("ADM_ERROR_TITLE")} line={L("ADM_ERROR_LINE")} reference="INC-7F3A2C" />
        <CopyCode code="INC-7F3A2C" />
      </section>
      <section data-ref="bloque-codigo">
        <h2 className="tm-subtitle">C53</h2>
        <CodeBlock
          title={L("ADM_SAMPLE_RESPONSE")}
          value={{
            content: "Te recomiendo el de 650 W con maletín. ¿Te lo separo?",
            usage: { input: 1240, output: 312 },
          }}
        />
      </section>
      <section data-ref="campo-contrasena">
        <h2 className="tm-subtitle">C54</h2>
        <div className="npa-pieces-field">
          <PasswordField
            id="pieces-secret"
            label={L("ADM_SAMPLE_KEY_LABEL")}
            value={secret}
            onChange={setSecret}
            autoComplete="new-password"
          />
        </div>
      </section>
      <section data-ref="paginado">
        <h2 className="tm-subtitle">C28</h2>
        <Pager total={63} page={1} pageSize={10} />
        <Pager total={32} page={1} pageSize={50} />
      </section>
    </div>
  );
}
